import React from "react";
import { Card, Table, Badge } from '@themesberg/react-bootstrap';

export default ({ data }) => {
    if (!data) return null;

    const { options, totalScore, approved } = data;

    return (
        <>
            {/* Summary Card */}
            <Card className="mb-4 shadow-sm">
                <Card.Header className="bg-primary text-white">
                    <h5 className="mb-0">Resumen de Calificación</h5>
                </Card.Header>
                <Card.Body>
                    <Table borderless className="mb-0">
                        <tbody>
                            <tr>
                                <td className="fw-bold" style={{ width: '40%' }}>Puntuación Total:</td>
                                <td>
                                    <span className="fs-4 fw-bold text-primary">
                                        {totalScore !== null && totalScore !== undefined ? totalScore.toFixed(2) : 'N/A'}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td className="fw-bold">Estado de Aprobación:</td>
                                <td>
                                    <Badge bg={approved ? "success" : "warning"} className="px-3 py-2">
                                        {approved ? "Aprobado" : "Pendiente"}
                                    </Badge>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {/* Options Details */}
            {options && options.length > 0 && options.map((option, optionIndex) => (
                <Card key={optionIndex} className="mb-4 shadow-sm">
                    <Card.Header className="bg-secondary text-white">
                        <h5 className="mb-0">
                            {(option.detailOptions && option.detailOptions.length > 0 && option.detailOptions[0].value)
                                || option.name
                                || `Opción ${optionIndex + 1}`}
                        </h5>
                    </Card.Header>
                    <Card.Body>
                        {/* Detail Options */}
                        {option.detailOptions && option.detailOptions.length > 0 && (
                            <div className="table-responsive">
                                {option.detailOptions.map((detail, detailIndex) => (
                                    <div key={detailIndex} className="mb-3">
                                        <div className="fw-bold bg-light p-2 border">
                                            {detail.description || 'N/A'}
                                        </div>
                                        <Table bordered hover className="mb-0">
                                            <thead className="bg-light">
                                                <tr>
                                                    <th style={{ width: '50%' }}>Valor</th>
                                                    <th style={{ width: '50%' }}>Detalles</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        {detail.valueOptions && detail.valueOptions.length > 0 ? (
                                                            detail.valueOptions.map((valueOpt, valIndex) => (
                                                                <span key={valIndex}>
                                                                    {valueOpt.value || 'N/A'}
                                                                    {valIndex < detail.valueOptions.length - 1 && ', '}
                                                                </span>
                                                            ))
                                                        ) : (
                                                            <span className="text-muted">Sin valor</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <small>
                                                            {detail.tooltip && (
                                                                <div className="mb-1">
                                                                    <strong>Tooltip:</strong> {detail.tooltip}
                                                                </div>
                                                            )}
                                                            {detail.editable !== null && detail.editable !== undefined && (
                                                                <div>
                                                                    <strong>Editable:</strong> {detail.editable ? 'Sí' : 'No'}
                                                                </div>
                                                            )}
                                                            {detail.orden !== null && detail.orden !== undefined && (
                                                                <div>
                                                                    <strong>Orden:</strong> {detail.orden}
                                                                </div>
                                                            )}
                                                            {detail.link && (
                                                                <div>
                                                                    <a href={detail.link} target="_blank" rel="noopener noreferrer">
                                                                        Ver enlace
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </small>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                ))}
                            </div>
                        )}
                    </Card.Body>
                </Card>
            ))}

            {(!options || options.length === 0) && (
                <Card className="text-center p-4">
                    <p className="text-muted">No hay opciones disponibles para mostrar.</p>
                </Card>
            )}
        </>
    );
};
